/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '@salesforce/retail-react-app/app/components/field'
import useTrackOrderFields from '../useTrackOrderFields'

const TrackOrderFields = ({form, prefix = ''}) => {
    const fields = useTrackOrderFields({form, prefix})
    return (
        <Stack spacing={{base: '15px', lg: 5}}>
            <Stack>
                <Field {...fields.orderNo} />
            </Stack>
            <Stack>
                <Field {...fields.email} />
            </Stack>
            <Stack>
                <Field {...fields.zipcode} />
            </Stack>
        </Stack>
    )
}

TrackOrderFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default TrackOrderFields
